import React from "react";
import { Link } from "react-router-dom";
import { LocalStorageItem, RoutePath } from "taskpane/models/enums";
import "../styles/welcomeText.css";

const WelcomeText: React.FC = (): React.JSX.Element => {
  const onClickButtonAgree = (): void => {
    localStorage.setItem(LocalStorageItem.licenceAgree, "true");
  };

  return (
    <div className="welcomeContainer">
      <h1 className="welcomeContainer__welcomeText">Добро пожаловать в VK Teams</h1>
      <p className="welcomeContainer__agreeText">
        Нажимая «Принять и продолжить» вы подтверждаете, что внимательно прочитали и соглашаетесь с нашими{" "}
        <a href="https://teams.vk.com/terms">Условиями предоставления услуг</a> и{" "}
        <a href="https://teams.vk.com/privacy">Политикой конфиденциальности</a>
      </p>
      <Link
        to={RoutePath.loginPage}
        onClick={onClickButtonAgree}
        className="welcomeContainer__buttonConfirm"
        data-testid="buttonAgree"
      >
        Принять и продолжить
      </Link>
    </div>
  );
};

export default WelcomeText;
